import * as Styled from './PunchupCustomFieldsResponses.styles';

import { downloadXLSFile, sendGAEvent, useDebounce } from 'utils/utils';

import { CustomFieldsResponsesProps } from '../types';
import { DateTime } from 'luxon';
import { IdParamsType } from 'utils/types';
import { PunchupResponsesTable } from '../components/PunchupResponsesTable/PunchupResponsesTable';
import { PunchupSearch } from 'features/common/components/PunchupSearch';
import { PunchupShowDashboardPage } from 'features/common/components/Punchup/ShowDashboardPage/PunchupShowDashboardPage';
import { getData } from 'services/api';
import { useEventCustomFields } from '../hooks/useEventCustomFields';
import useGetEvent from 'features/common/hooks/useGetEvent';
import { useParams } from 'react-router-dom';
import { useSwitchTicketBridge } from '../hooks/useSwitchTicketBridge';
import { useTranslation } from 'react-i18next';

export const PunchupCustomFieldsResponses = ({ isAttendeesList = false }: CustomFieldsResponsesProps) => {
	const { t } = useTranslation();

	const { event } = useGetEvent();
	const { id } = useParams<IdParamsType>();
	const { setSearchText, responsesQueryObject, sortBy, order, handleSort } = useEventCustomFields(isAttendeesList);
	useSwitchTicketBridge();

	const searchDebounce = useDebounce(setSearchText);

	const handleDownload = async () => {
		const response = await getData(`/events/${id}/custom-fields/responses/download`, {
			params: { all_attendees: isAttendeesList },
			responseType: 'blob',
			headers: { 'Content-Type': 'blob' },
		});

		let fileName = event?.name ? event.name.replace(/[^a-zA-Z0-9]/g, ' ') : 'Attendees';
		if (event?.startDate) {
			const timezone = event.timeZone || 'UTC';
			const startDateTime = DateTime.fromISO(event.startDate, { zone: timezone });
			const formattedDate = startDateTime.toFormat('MMM dd hh:mm a').replace(/:/g, '.');
			fileName += ` (${formattedDate})`;
		}

		downloadXLSFile(response, fileName);
		sendGAEvent({ category: 'Custom Fields', action: 'Custom Fields Responses download' });
	};

	return (
		<PunchupShowDashboardPage pageName={isAttendeesList ? 'Attendee List' : 'Custom Fields'}>
			<Styled.Container>
				<Styled.CustomFlexContainer>
					<PunchupSearch
						width="300px"
						onChange={(e) => searchDebounce(e.target.value)}
						placeholder={t('search-email-or-name-attendees')}
					/>

					<Styled.Buttons>
						<Styled.CsvButton onClick={handleDownload}>{t('customFields-responses-download')}</Styled.CsvButton>
					</Styled.Buttons>
				</Styled.CustomFlexContainer>

				<PunchupResponsesTable
					responsesQueryObject={responsesQueryObject}
					isAttendeesList={isAttendeesList}
					eventMode={event?.mode || 'normal'}
					sortBy={sortBy}
					order={order}
					onSort={handleSort}
				></PunchupResponsesTable>
			</Styled.Container>
		</PunchupShowDashboardPage>
	);
};
